/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PairRouteImport } from './routes/pair'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings.integrations'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsCloudRouteImport } from './routes/settings.cloud'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as ProjectsProjectKeyRouteImport } from './routes/projects.$projectKey'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as ChatPullRequestsRouteImport } from './routes/_chat.pull-requests'
import { Route as ProjectsProjectKeyVmRouteImport } from './routes/projects.$projectKey_.vm'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'

const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCloudRoute = SettingsCloudRouteImport.update({
  id: '/cloud',
  path: '/cloud',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsProjectKeyRoute = ProjectsProjectKeyRouteImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatPullRequestsRoute = ChatPullRequestsRouteImport.update({
  id: '/pull-requests',
  path: '/pull-requests',
  getParentRoute: () => ChatRoute,
} as any)
const ProjectsProjectKeyVmRoute = ProjectsProjectKeyVmRouteImport.update({
  id: '/projects/$projectKey_/vm',
  path: '/projects/$projectKey/vm',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/projects/$projectKey/vm': typeof ProjectsProjectKeyVmRoute
}
export interface FileRoutesByTo {
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/projects/$projectKey/vm': typeof ProjectsProjectKeyVmRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/_chat/pull-requests': typeof ChatPullRequestsRoute
  '/connect_/callback': typeof ConnectCallbackRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/projects/$projectKey_/vm': typeof ProjectsProjectKeyVmRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/pull-requests'
    | '/connect/callback'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/cloud'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/projects/$projectKey/vm'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/pull-requests'
    | '/connect/callback'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/cloud'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/projects/$projectKey/vm'
  id:
    | '__root__'
    | '/_chat'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/_chat/pull-requests'
    | '/connect_/callback'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/cloud'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
    | '/projects/$projectKey_/vm'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  ConnectRoute: typeof ConnectRoute
  PairRoute: typeof PairRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageRoute: typeof UsageRoute
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  ProjectsProjectKeyRoute: typeof ProjectsProjectKeyRoute
  ProjectsProjectKeyVmRoute: typeof ProjectsProjectKeyVmRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cloud': {
      id: '/settings/cloud'
      path: '/cloud'
      fullPath: '/settings/cloud'
      preLoaderRoute: typeof SettingsCloudRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$projectKey': {
      id: '/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof ProjectsProjectKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/pull-requests': {
      id: '/_chat/pull-requests'
      path: '/pull-requests'
      fullPath: '/pull-requests'
      preLoaderRoute: typeof ChatPullRequestsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/projects/$projectKey_/vm': {
      id: '/projects/$projectKey_/vm'
      path: '/projects/$projectKey/vm'
      fullPath: '/projects/$projectKey/vm'
      preLoaderRoute: typeof ProjectsProjectKeyVmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatPullRequestsRoute: typeof ChatPullRequestsRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatPullRequestsRoute: ChatPullRequestsRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsCloudRoute: typeof SettingsCloudRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsCloudRoute: SettingsCloudRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  ConnectRoute: ConnectRoute,
  PairRoute: PairRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UsageRoute: UsageRoute,
  ConnectCallbackRoute: ConnectCallbackRoute,
  ProjectsProjectKeyRoute: ProjectsProjectKeyRoute,
  ProjectsProjectKeyVmRoute: ProjectsProjectKeyVmRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
